export default __webpack_public_path__ + "static/media/outlook.6c66848d.svg";